module.exports = __webpack_public_path__ + "31cb4c3acc32e2ff0175cfc045957f93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/picmobile15.png
// module id = 1875
// module chunks = 0